import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/Layout";
import { api } from "@/lib/api";
import { Newspaper, ArrowUpRight } from "lucide-react";

export default function BlogList() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    document.title = "Eventom Blog — News, Guides & Live Culture Stories";
    api.get("/blogs").then(({ data }) => setPosts(data || [])).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <Layout>
      <section className="max-w-6xl mx-auto px-4 sm:px-6 py-12" data-testid="blog-list-page">
        <div className="chip !text-lime !border-lime/40 mb-3"><Newspaper className="w-3 h-3" /> Eventom Journal</div>
        <h1 className="font-display uppercase text-4xl md:text-6xl leading-[0.95]">News. Guides. <span className="grad-text-hot">Live culture.</span></h1>
        <p className="mt-3 text-muted max-w-2xl">Playbooks for organisers, city guides for fans, and the drops we're most excited about — straight from the Eventom team.</p>

        {loading ? (
          <div className="mt-8 glass p-6 font-mono text-sm text-muted">Loading stories…</div>
        ) : posts.length === 0 ? (
          <div className="mt-8 glass p-8 text-center" data-testid="blog-empty">
            <div className="font-heading font-bold text-lg">The journal is opening up.</div>
            <div className="text-sm text-muted mt-1">Our first stories drop soon — check back shortly.</div>
          </div>
        ) : (
          <div className="mt-8 grid md:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="blog-grid">
            {posts.map((p) => (
              <Link to={`/blog/${p.slug}`} key={p.id} data-testid={`blog-card-${p.slug}`} className="glass rounded-3xl overflow-hidden card-lift block">
                {p.cover_url ? (
                  <div className="aspect-[16/9] overflow-hidden">
                    <img src={p.cover_url} alt={p.title} loading="lazy" className="w-full h-full object-cover" />
                  </div>
                ) : (
                  <div className="aspect-[16/9] bg-gradient-to-br from-lime/20 via-purple/20 to-magenta/20 flex items-center justify-center"><Newspaper className="w-10 h-10 text-white/40" /></div>
                )}
                <div className="p-5">
                  {p.tags?.length ? (
                    <div className="flex flex-wrap gap-1.5 mb-2">
                      {p.tags.slice(0, 3).map((t) => <span key={t} className="text-[9px] font-mono uppercase tracking-widest px-2 py-0.5 rounded-full bg-white/10 text-muted">{t}</span>)}
                    </div>
                  ) : null}
                  <div className="font-display text-xl uppercase leading-tight">{p.title}</div>
                  {p.excerpt && <div className="text-sm text-white/70 mt-2 line-clamp-3">{p.excerpt}</div>}
                  <div className="mt-3 text-[11px] font-mono uppercase tracking-widest text-lime inline-flex items-center gap-1">Read <ArrowUpRight className="w-3 h-3" /></div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
    </Layout>
  );
}
